/* js/app.js - Main Application Logic */
document.addEventListener('DOMContentLoaded', () => {
  // Initialize animations
  if (typeof initAnimations === 'function') {
    initAnimations();
  }

  // Initialize navigation
  if (typeof initNavigation === 'function') {
    initNavigation();
  }

  // Initialize smooth scroll
  initSmoothScroll();
});

function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;
      
      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        e.preventDefault();
        targetElement.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
  });
}
